<template>
  <el-card class="collection-card" @click.native="$emit('click')">
    <div class="collection-layout">
      <div class="collection-cover">
        <CachedImage
          :src="collection.cover_url"
          :fallback-src="placeholderImage"
          fit="cover"
          width="100%"
          height="100%"
          lazy
        />
      </div>
      <div class="collection-info">
        <h4>{{ collection.title }}</h4>
        <CollectionSpecialLabels :labels="collection.special_labels" />
        <p>{{ collection.description || 'No description' }}</p>
        <div class="collection-price">
          Free
        </div>
        <div v-if="collection.order_info" class="collection-actions">
          <el-button 
            size="small" 
            @click="handleShowOrderSettings"
            style="border-color: #409eff; color: #409eff;"
          >
            Order & Settings
          </el-button>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import CollectionSpecialLabels from "@/components/CollectionSpecialLabels.vue";
import CachedImage from '@/components/CachedImage.vue'

export default {
  name: 'CollectionSimpleCard',
  components: {
    CollectionSpecialLabels,
    CachedImage
  },
  props: {
    collection: {
      type: Object,
      required: true
    }
  },
  emits: ['click', 'showOrderSettings'],
  data() {
    return {
      placeholderImage: require('@/assets/Card Collection Cover Placeholder.jpeg')
    }
  },
  methods: {
    handleShowOrderSettings(event) {
      event.stopPropagation();
      this.$emit('showOrderSettings');
    }
  }
}
</script>

<style scoped>
.collection-card {
  width: 100%;
  transition: transform 0.2s;
  aspect-ratio: 5/2;
  display: flex;
  cursor: pointer;
}

.collection-card :deep(.el-card__body) {
  width: 100%;
  height: 100%;
  padding: 0;
  display: flex;
}

.collection-layout {
  display: flex;
  gap: 5px;
  width: 100%;
  height: 100%;
}

.collection-cover {
  height: 85%;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  aspect-ratio: 5/7;
  margin-top: 2.5%;
  margin-left: 2.5%;
  background-color: #f5f7fa;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.cover-image {
  width: 100%;
  height: 100%;
  transition: transform 0.3s ease;
}

.cover-image:hover {
  transform: scale(1.05);
}

.image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 24px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.image-placeholder i {
  font-size: 32px;
  color: #c0c4cc;
}

.image-placeholder .placeholder-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.collection-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 2.5px 10px;
  margin-top: 2.5%;
  position: relative;
}

.collection-info h4 {
  margin: 0 0 5px 0;
  color: #303133;
  font-size: 1em;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

.collection-info p {
  color: #606266;
  font-size: 0.9em;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.collection-price {
  position: absolute;
  bottom: 10px;
  left: 10px;
  color: #409EFF;
  font-weight: bold;
  font-size: 1.1em;
}

.collection-actions {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
</style> 